// Square payment flow - vanilla JS with fetch
let is_shipping = false;
let total = "0.00";
let line_items = "";
let card = null;
let formPaymentRequest = null;

function getTicketInfoFormData() {
  const ticketInfo = document.getElementById("ticket-information");
  if (!ticketInfo) return new URLSearchParams();
  const fd = new FormData();
  ticketInfo.querySelectorAll("input, select").forEach((el) => {
    if (!el.name) return;
    if (el.type === "checkbox" || el.type === "radio") {
      if (el.checked) fd.append(el.name, el.value);
    } else {
      fd.append(el.name, el.value);
    }
  });
  return new URLSearchParams(fd);
}

function getCartFormAction() {
  const cart = document.getElementById("cart");
  if (!cart) return null;
  const form = cart.querySelector(".new_customer") || cart.querySelector(".edit_customer");
  return form?.getAttribute("action");
}

const url_ajax = getCartFormAction();

function isCartApplePayFlow() {
  return !!url_ajax && !!document.getElementById("cart");
}

function merchantLabel() {
  return window.appType === "FOS" ? "Field of Screams" : "Corn Cob Acres";
}

function getSquareTotalAmount() {
  const raw = document.getElementById("total_for_square")?.textContent || "0";
  const amount = Number.parseFloat(raw);
  if (!Number.isFinite(amount) || amount < 0) return "0.00";
  return amount.toFixed(2);
}

function showCartErrors(errorHtml) {
  if (!errorHtml) return;
  const err = document.getElementById("error_explanation");
  if (err) err.remove();
  const ticketInfo = document.getElementById("ticket-information");
  if (ticketInfo) {
    const div = document.createElement("div");
    div.innerHTML = errorHtml;
    const toInsert = div.firstElementChild || div;
    ticketInfo.parentNode.insertBefore(toInsert, ticketInfo);
  }
  updateApplePayButtonState();
}

function updateApplePayButtonState() {
  const hasErrors = document.getElementById("error_explanation") !== null;
  const applePayBtn = document.getElementById("apple-pay-button");
  if (applePayBtn) {
    applePayBtn.disabled = hasErrors;
    applePayBtn.setAttribute("aria-disabled", hasErrors);
  }
}

window.updateApplePayButtonVisibility = function () {
  const applePayBtn = document.getElementById("apple-pay-button");
  if (!applePayBtn) return;
  const amount = Number.parseFloat(getSquareTotalAmount());
  applePayBtn.style.display = amount > 0 ? "" : "none";
};

function isEmptyObject(obj) {
  return obj && Object.keys(obj).length === 0;
}

function getFormApplePayPaymentRequest() {
  // Square may reject a $0 payment request at init; keep a tiny placeholder while
  // the button is hidden, then sync the real amount on click before tokenize.
  let amount = getSquareTotalAmount();
  if (Number.parseFloat(amount) <= 0) amount = "0.01";

  return {
    countryCode: "US",
    currencyCode: "USD",
    lineItems: [{ amount, label: "Total", pending: false }],
    requestBillingContact: true,
    requestShippingContact: false,
    total: {
      amount,
      label: merchantLabel(),
      pending: false,
    },
  };
}

function syncFormApplePayPaymentRequest() {
  if (!formPaymentRequest) return false;
  const amount = getSquareTotalAmount();
  return formPaymentRequest.update({
    lineItems: [{ amount, label: "Total", pending: false }],
    total: {
      amount,
      label: merchantLabel(),
      pending: false,
    },
  });
}

async function getApplePayPaymentRequest() {
  if (!isCartApplePayFlow()) {
    return getFormApplePayPaymentRequest();
  }

  const res = await fetch(url_ajax, {
    method: "PUT",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
      Accept: "application/json",
    },
    body: getTicketInfoFormData().toString(),
  });
  const data = await res.json();
  if (data.cart_changed && data.redirect) {
    window.location.href = data.redirect;
    throw new Error("Cart has changed");
  }
  if (data.errors != null && !isEmptyObject(data.errors)) {
    showCartErrors(data.errors);
    throw new Error("Cart has errors");
  }
  total = data.total;
  line_items = data.line_items_apple_pay;
  if (data.is_shipping) {
    is_shipping = true;
  }
  return {
    countryCode: "US",
    currencyCode: "USD",
    lineItems: line_items,
    requestBillingContact: true,
    requestShippingContact: is_shipping,
    total: {
      amount: total,
      label: merchantLabel(),
      pending: false,
    },
  };
}

window.showSuccess = function (message) {
  if (window.paymentFlowMessageEl) {
    window.paymentFlowMessageEl.classList.add("success");
    window.paymentFlowMessageEl.classList.remove("error");
    window.paymentFlowMessageEl.innerText = message;
  }
};

window.showError = function (message) {
  if (window.paymentFlowMessageEl) {
    window.paymentFlowMessageEl.classList.add("error");
    window.paymentFlowMessageEl.classList.remove("success");
    window.paymentFlowMessageEl.innerText = message;
  }
};

const VERIFYING_STATUS_ID = "square-verifying-status";
const VERIFYING_MESSAGE = "Verifying your card. This can take a few seconds.";
let tokenizeInProgress = false;

function getCheckoutSubmitButton() {
  return (
    document.getElementById("continue_button") ||
    document.getElementById("date-change-submit") ||
    document.getElementById("vip-upgrade-submit")
  );
}

function pageAlreadyShowsProcessing() {
  return !!(
    document.getElementById("date-change-processing") ||
    document.getElementById("vip-upgrade-processing") ||
    document.getElementById("order-processing")
  );
}

function ensureStatusEl() {
  let status = document.getElementById(VERIFYING_STATUS_ID);
  if (!status) {
    status = document.createElement("div");
    status.id = VERIFYING_STATUS_ID;

    const btn = getCheckoutSubmitButton();
    const formfield = btn?.closest(".formfield");
    const notice = formfield?.querySelector("p.notice");
    if (notice) {
      formfield.insertBefore(status, notice);
    } else if (formfield) {
      formfield.appendChild(status);
    } else {
      const parent = document.getElementById("order_form") || document.getElementById("registration_form");
      if (parent) parent.appendChild(status);
    }
  }

  status.classList.add("flash");
  status.setAttribute("role", "status");
  status.setAttribute("aria-live", "polite");
  return status;
}

function setStatusFlash(kind, message) {
  const status = ensureStatusEl();
  if (!status) return;
  status.replaceChildren();
  const box = document.createElement("div");
  box.className = kind;
  const p = document.createElement("p");
  p.textContent = message;
  box.appendChild(p);
  status.appendChild(box);
  status.scrollIntoView({ behavior: "smooth", block: "nearest" });
}

function restoreCheckoutSubmitButton() {
  const btn = getCheckoutSubmitButton();
  if (!btn) return;
  btn.disabled = false;
  if (btn.dataset.originalValue) btn.value = btn.dataset.originalValue;
}

window.squareShowVerifying = function (message) {
  const btn = getCheckoutSubmitButton();
  if (btn) {
    if (!btn.dataset.originalValue) btn.dataset.originalValue = btn.value;
    btn.disabled = true;
    btn.value = "Please wait...";
  }

  if (pageAlreadyShowsProcessing()) return;

  setStatusFlash("information", message || VERIFYING_MESSAGE);
};

window.squareHideVerifying = function () {
  restoreCheckoutSubmitButton();
  const status = document.getElementById(VERIFYING_STATUS_ID);
  if (status) status.replaceChildren();
};

function failTokenize(message) {
  tokenizeInProgress = false;
  restoreCheckoutSubmitButton();
  setStatusFlash("error", message);
  showError(message);
  notifyPaymentFailed();
}

function tokenizeFailureMessage(result) {
  const status = result?.status;
  if (status === "Cancel" || status === "Abort") {
    return "Card verification was cancelled. Please try again.";
  }
  if (status === "Invalid") {
    return "Please check your card details and try again.";
  }
  const firstError = Array.isArray(result?.errors) ? result.errors[0] : null;
  return firstError?.message || "We could not verify your card. Please try again.";
}

function notifyPaymentSubmitting() {
  document.dispatchEvent(new CustomEvent("square:payment-submitting"));
}

function notifyPaymentFailed() {
  document.dispatchEvent(new CustomEvent("square:payment-failed"));
}

async function CardPay(fieldEl) {
  const cardContainer = document.getElementById("card-container");
  if (!cardContainer) return;

  try {
  const darkModeCardStyle =
    window.appType === "FOS"
      ? {
          ".input-container": { borderColor: "#2D2D2D", borderRadius: "6px" },
          ".input-container.is-focus": { borderColor: "#006AFF" },
          ".input-container.is-error": { borderColor: "#ff1600" },
          ".message-text": { color: "#c5c5c5" },
          ".message-icon": { color: "#c5c5c5" },
          ".message-text.is-error": { color: "#ff1600" },
          ".message-icon.is-error": { color: "#ff1600" },
          input: { backgroundColor: "#2D2D2D", color: "#FFFFFF", fontFamily: "helvetica neue, sans-serif" },
          "input::placeholder": { color: "#c5c5c5" },
          "input.is-error": { color: "#ff1600" },
          "@media screen and (max-width: 600px)": { input: { fontSize: "12px" } },
        }
      : null;

  const zipEl = document.getElementById("customer_zip");
  card = await window.payments.card({
    style: darkModeCardStyle,
    postalCode: zipEl?.value ?? "",
  });
  await card.attach(fieldEl);
  } catch (e) {
    console.error(e);
    showError(e?.message || "Could not load the payment form. If this continues, contact support.");
  }
}

function shouldSkipSquareTokenize() {
  if (!window.enableSquare) return true;

  const adminField = document.querySelector('input[name="credit_card[admin]"]');
  if (adminField?.value === "true") return true;

  if (!document.getElementById("card-container")) return true;

  const totalEl = document.getElementById("total_for_square");
  if (Number(totalEl?.textContent || 0) <= 0) return true;

  return false;
}

function submitOrderForm() {
  const form = document.getElementById("order_form");
  if (form) form.submit();
}

function fillSquareTokenFields(tokenDetails) {
  const idempotencyInput = document.getElementById("credit_card_idempotency_key");
  const tokenInput = document.getElementById("credit_card_token");
  if (idempotencyInput) idempotencyInput.value = window.idempotencyKey;
  if (tokenInput) tokenInput.value = tokenDetails.token;

  const cardDetails = tokenDetails.details?.card;
  if (!cardDetails) return;

  const cardNumInput = document.getElementById("credit_card_card_number");
  const expMonthInput = document.getElementById("credit_card_expiration_date_2i");
  const expYearInput = document.getElementById("credit_card_expiration_date_1i");
  if (cardNumInput && cardDetails.last4) cardNumInput.value = cardDetails.last4;
  if (expMonthInput && cardDetails.expMonth) expMonthInput.value = cardDetails.expMonth;
  if (expYearInput && cardDetails.expYear) expYearInput.value = cardDetails.expYear;
}

window.squareStartTokenize = async function () {
  if (shouldSkipSquareTokenize()) {
    submitOrderForm();
    return;
  }
  if (tokenizeInProgress) return;

  tokenizeInProgress = true;
  window.squareShowVerifying();
  if (window.paymentFlowMessageEl) window.paymentFlowMessageEl.innerText = "";

  const totalEl = document.getElementById("total_for_square");
  const verificationDetails = {
    amount: (totalEl?.textContent || "0").trim(),
    billingContact: {
      givenName: document.getElementById("customer_first_name")?.value,
      familyName: document.getElementById("customer_last_name")?.value,
      email: document.getElementById("customer_email")?.value,
      phone: document.getElementById("customer_phone")?.value,
      addressLines: [document.getElementById("customer_address")?.value],
      city: document.getElementById("customer_city")?.value,
      state: document.getElementById("customer_state")?.value,
      countryCode: document.getElementById("customer_country_code")?.value,
    },
    currencyCode: "USD",
    intent: "CHARGE",
    customerInitiated: true,
    sellerKeyedIn: false,
  };

  if (!card) {
    failTokenize("Payment form is not available. Please refresh the page and try again.");
    return;
  }

  try {
    const result = await card.tokenize(verificationDetails);
    if (result.status === "OK") {
      fillSquareTokenFields(result);
      submitOrderForm();
      return;
    }
    console.error("Square tokenize failed", result);
    failTokenize(tokenizeFailureMessage(result));
  } catch (e) {
    console.error(e);
    failTokenize(e?.message || "We could not verify your card. Please try again.");
  }
};

async function ApplePay(buttonEl) {
  const applePayBtn = document.getElementById("apple-pay-button");
  if (!applePayBtn) return;

  updateApplePayButtonState();
  window.updateApplePayButtonVisibility();

  let paymentRequestData;
  try {
    paymentRequestData = await getApplePayPaymentRequest();
  } catch (e) {
    return;
  }

  const paymentRequest = window.payments.paymentRequest(paymentRequestData);
  if (!isCartApplePayFlow()) {
    formPaymentRequest = paymentRequest;
  }

  if (isCartApplePayFlow()) {
    paymentRequest.addEventListener("shippingcontactchanged", async (shippingContact) => {
      if (is_shipping === false) {
        return { lineItems: line_items, shippingOptions: [], total };
      }
      const fd = getTicketInfoFormData();
      fd.set("customer[first_name]", shippingContact.givenName);
      fd.set("customer[last_name]", shippingContact.familyName);
      fd.set("customer[address]", "");
      fd.set("customer[city]", shippingContact.city);
      fd.set("customer[state]", shippingContact.state);
      fd.set("customer[zip]", shippingContact.postalCode);
      fd.set("customer[country_code]", shippingContact.countryCode);

      const res = await fetch(url_ajax, {
        method: "PUT",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
          Accept: "application/json",
        },
        body: fd.toString(),
      });
      const data = await res.json();
      if (data.cart_changed && data.redirect) {
        window.location.href = data.redirect;
        return;
      }
      if (data.errors != null && !isEmptyObject(data.errors)) {
        showCartErrors(data.errors);
        return;
      }
      total = data.total;
      line_items = data.line_items_apple_pay;
      const shipping_fee = String(data.shipping_fee || "0");

      return {
        lineItems: line_items,
        shippingOptions: [
          {
            label: "Shipping",
            id: "shipping-option",
            detail: "Shipping and Handling",
            amount: shipping_fee,
            identifier: "Shipping",
          },
        ],
        total: {
          type: "final",
          label: merchantLabel(),
          amount: total,
        },
      };
    });
  }

  let applePay;
  try {
    applePay = await window.payments.applePay(paymentRequest);
  } catch (e) {
    console.error(e);
    return;
  }

  async function eventHandler() {
    if (document.getElementById("error_explanation")) {
      updateApplePayButtonState();
      return;
    }
    if (window.paymentFlowMessageEl) window.paymentFlowMessageEl.innerText = "";

    if (!isCartApplePayFlow()) {
      const amount = Number.parseFloat(getSquareTotalAmount());
      if (!(amount > 0)) return;

      if (typeof window.squareApplePayValidate === "function" && !window.squareApplePayValidate()) {
        return;
      }

      syncFormApplePayPaymentRequest();
    }

    try {
      const result = await applePay.tokenize();
      if (result.status === "OK") {
        submitApplePayPayment(result);
        return;
      }
      console.error("Square Apple Pay tokenize failed", result);
      failTokenize(tokenizeFailureMessage(result));
    } catch (e) {
      console.error(e);
      failTokenize(e.message || "Something went wrong. Please try again.");
    }
  }

  buttonEl.addEventListener("click", eventHandler);
}

function submitApplePayFormPayment(tokenDetails) {
  fillSquareTokenFields(tokenDetails);
  notifyPaymentSubmitting();
  submitOrderForm();
}

function submitApplePayPayment(tokenDetails) {
  if (!isCartApplePayFlow()) {
    submitApplePayFormPayment(tokenDetails);
    return;
  }

  const body = JSON.stringify({
    dataDesc: "COMMON.APPLE.INAPP.PAYMENT",
    token: tokenDetails.token,
    idempotency_key: window.idempotencyKey,
    customer_billing: {
      addressLines: tokenDetails.details.billing.addressLines,
      familyName: tokenDetails.details.billing.familyName,
      givenName: tokenDetails.details.billing.givenName,
      administrativeArea: tokenDetails.details.billing.state,
      locality: tokenDetails.details.billing.city,
      postalCode: tokenDetails.details.billing.postalCode,
    },
    customer_shipping: {
      addressLines: tokenDetails.details.shipping?.contact?.addressLines,
      familyName: tokenDetails.details.shipping?.contact?.familyName,
      givenName: tokenDetails.details.shipping?.contact?.givenName,
      administrativeArea: tokenDetails.details.shipping?.contact?.state,
      locality: tokenDetails.details.shipping?.contact?.city,
      country: tokenDetails.details.shipping?.contact?.countryCode,
      postalCode: tokenDetails.details.shipping?.contact?.postalCode,
      emailAddress: tokenDetails.details.shipping?.contact?.email,
      phoneNumber: tokenDetails.details.shipping?.contact?.phone,
    },
  });

  fetch("/orders", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
      Accept: "text/plain",
    },
    body,
    credentials: "include",
  })
    .then(async (r) => {
      const text = await r.text();
      if (r.ok && (text.startsWith("/") || text.startsWith("http"))) {
        window.location.href = text;
      } else if (!r.ok) {
        let divText = "Unknown Apple Pay error has occured";
        try {
          const json = JSON.parse(text);
          if (json.redirect) {
            window.location.href = json.redirect;
            return;
          }
          if (json.status) divText = json.status;
        } catch {}
        const errorDiv = document.createElement("div");
        errorDiv.id = "error_explanation";
        errorDiv.innerHTML = `<h2 class="no-replacement">The Following Errors Were Caught</h2><ul><li>${divText}</li></ul>`;
        const ticketInfo = document.getElementById("ticket-information");
        if (ticketInfo) ticketInfo.parentNode.insertBefore(errorDiv, ticketInfo);
      }
    })
    .catch(() => {
      const errorDiv = document.createElement("div");
      errorDiv.id = "error_explanation";
      errorDiv.innerHTML = `<h2 class="no-replacement">The Following Errors Were Caught</h2><ul><li>Unknown Apple Pay error has occured</li></ul>`;
      const ticketInfo = document.getElementById("ticket-information");
      if (ticketInfo) ticketInfo.parentNode.insertBefore(errorDiv, ticketInfo);
    });
}

async function SquarePaymentFlow() {
  const cardEl = document.getElementById("card-container");
  const applePayEl = document.getElementById("apple-pay-button");
  // Card form and Apple Pay are independent; run both so Apple Pay is ready without waiting on iframes.
  await Promise.all([CardPay(cardEl), ApplePay(applePayEl)]);
}

function domReady(fn) {
  if (document.readyState !== "loading") fn();
  else document.addEventListener("DOMContentLoaded", fn);
}

domReady(() => {
  if (window.enableSquare) {
    window.payments = Square.payments(window.applicationId, window.locationId);
    window.paymentFlowMessageEl = document.getElementById("payment-flow-message");
    SquarePaymentFlow().catch((e) => console.error("SquarePaymentFlow", e));
  }
});

// Zip change - reconfigure card (card is set after CardPay async)
domReady(() => {
  const zipEl = document.getElementById("customer_zip");
  if (zipEl) {
    zipEl.addEventListener("change", () => {
      if (card) card.configure({ postalCode: zipEl.value });
    });
  }
});
